var render = function render(){var _vm=this,_c=_vm._self._c;return _c('strong',{staticClass:"price"},[_vm._v(_vm._s(_vm.symbol)+_vm._s(_vm.converted))])
}
var staticRenderFns = []

export { render, staticRenderFns }